import { Routes } from '@angular/router';
import { HMI_PANO_ROUTES } from '@shared';

// Remote, shared'daki gerçek HMI pano route ağacını expose eder.
// Host (kabuk) `/hmi-pano` altında bunu yükler; child route'lar shared
// içindeki gerçek bileşenleri lazy load eder.
export const routes: Routes = HMI_PANO_ROUTES;

